/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.extra.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.extra = {};
proto.witbooking.backoffice.extra.v1 = require('./extra_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.extra.v1.GetExtrasRequest,
 *   !proto.witbooking.backoffice.extra.v1.GetExtrasResponse>}
 */
const methodDescriptor_ExtraAPI_GetExtras = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.extra.v1.ExtraAPI/GetExtras',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.extra.v1.GetExtrasRequest,
  proto.witbooking.backoffice.extra.v1.GetExtrasResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.GetExtrasRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.GetExtrasResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.extra.v1.GetExtrasRequest,
 *   !proto.witbooking.backoffice.extra.v1.GetExtrasResponse>}
 */
const methodInfo_ExtraAPI_GetExtras = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.extra.v1.GetExtrasResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.GetExtrasRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.GetExtrasResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtrasRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.extra.v1.GetExtrasResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.extra.v1.GetExtrasResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIClient.prototype.getExtras =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/GetExtras',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_GetExtras,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtrasRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.extra.v1.GetExtrasResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIPromiseClient.prototype.getExtras =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/GetExtras',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_GetExtras);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.extra.v1.GetExtraRequest,
 *   !proto.witbooking.backoffice.extra.v1.GetExtraResponse>}
 */
const methodDescriptor_ExtraAPI_GetExtra = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.extra.v1.ExtraAPI/GetExtra',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.extra.v1.GetExtraRequest,
  proto.witbooking.backoffice.extra.v1.GetExtraResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.GetExtraRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.GetExtraResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.extra.v1.GetExtraRequest,
 *   !proto.witbooking.backoffice.extra.v1.GetExtraResponse>}
 */
const methodInfo_ExtraAPI_GetExtra = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.extra.v1.GetExtraResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.GetExtraRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.GetExtraResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtraRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.extra.v1.GetExtraResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.extra.v1.GetExtraResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIClient.prototype.getExtra =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/GetExtra',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_GetExtra,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.GetExtraRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.extra.v1.GetExtraResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIPromiseClient.prototype.getExtra =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/GetExtra',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_GetExtra);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.extra.v1.CreateExtraRequest,
 *   !proto.witbooking.backoffice.extra.v1.CreateExtraResponse>}
 */
const methodDescriptor_ExtraAPI_CreateExtra = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.extra.v1.ExtraAPI/CreateExtra',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.extra.v1.CreateExtraRequest,
  proto.witbooking.backoffice.extra.v1.CreateExtraResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.CreateExtraRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.CreateExtraResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.extra.v1.CreateExtraRequest,
 *   !proto.witbooking.backoffice.extra.v1.CreateExtraResponse>}
 */
const methodInfo_ExtraAPI_CreateExtra = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.extra.v1.CreateExtraResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.CreateExtraRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.CreateExtraResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.extra.v1.CreateExtraRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.extra.v1.CreateExtraResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.extra.v1.CreateExtraResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIClient.prototype.createExtra =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/CreateExtra',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_CreateExtra,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.CreateExtraRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.extra.v1.CreateExtraResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIPromiseClient.prototype.createExtra =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/CreateExtra',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_CreateExtra);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.extra.v1.UpdateExtraRequest,
 *   !proto.witbooking.backoffice.extra.v1.UpdateExtraResponse>}
 */
const methodDescriptor_ExtraAPI_UpdateExtra = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.extra.v1.ExtraAPI/UpdateExtra',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.extra.v1.UpdateExtraRequest,
  proto.witbooking.backoffice.extra.v1.UpdateExtraResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.UpdateExtraRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.UpdateExtraResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.extra.v1.UpdateExtraRequest,
 *   !proto.witbooking.backoffice.extra.v1.UpdateExtraResponse>}
 */
const methodInfo_ExtraAPI_UpdateExtra = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.extra.v1.UpdateExtraResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.UpdateExtraRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.UpdateExtraResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.extra.v1.UpdateExtraRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.extra.v1.UpdateExtraResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.extra.v1.UpdateExtraResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIClient.prototype.updateExtra =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/UpdateExtra',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_UpdateExtra,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.UpdateExtraRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.extra.v1.UpdateExtraResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIPromiseClient.prototype.updateExtra =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/UpdateExtra',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_UpdateExtra);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest,
 *   !proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse>}
 */
const methodDescriptor_ExtraAPI_GetAllExtras = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.extra.v1.ExtraAPI/GetAllExtras',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest,
  proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest,
 *   !proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse>}
 */
const methodInfo_ExtraAPI_GetAllExtras = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIClient.prototype.getAllExtras =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/GetAllExtras',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_GetAllExtras,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.GetAllExtrasRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.extra.v1.GetAllExtrasResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIPromiseClient.prototype.getAllExtras =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/GetAllExtras',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_GetAllExtras);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.extra.v1.FilterExtrasRequest,
 *   !proto.witbooking.backoffice.extra.v1.FilterExtrasResponse>}
 */
const methodDescriptor_ExtraAPI_FilterExtras = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.extra.v1.ExtraAPI/FilterExtras',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.extra.v1.FilterExtrasRequest,
  proto.witbooking.backoffice.extra.v1.FilterExtrasResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.FilterExtrasRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.extra.v1.FilterExtrasRequest,
 *   !proto.witbooking.backoffice.extra.v1.FilterExtrasResponse>}
 */
const methodInfo_ExtraAPI_FilterExtras = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.extra.v1.FilterExtrasResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.FilterExtrasRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.FilterExtrasResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.extra.v1.FilterExtrasRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.extra.v1.FilterExtrasResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.extra.v1.FilterExtrasResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIClient.prototype.filterExtras =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/FilterExtras',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_FilterExtras,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.FilterExtrasRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.extra.v1.FilterExtrasResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIPromiseClient.prototype.filterExtras =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/FilterExtras',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_FilterExtras);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.extra.v1.DeleteExtraRequest,
 *   !proto.witbooking.backoffice.extra.v1.DeleteExtraResponse>}
 */
const methodDescriptor_ExtraAPI_DeleteExtra = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.extra.v1.ExtraAPI/DeleteExtra',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.extra.v1.DeleteExtraRequest,
  proto.witbooking.backoffice.extra.v1.DeleteExtraResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.DeleteExtraRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.DeleteExtraResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.extra.v1.DeleteExtraRequest,
 *   !proto.witbooking.backoffice.extra.v1.DeleteExtraResponse>}
 */
const methodInfo_ExtraAPI_DeleteExtra = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.extra.v1.DeleteExtraResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.DeleteExtraRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.DeleteExtraResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.extra.v1.DeleteExtraRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.extra.v1.DeleteExtraResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.extra.v1.DeleteExtraResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIClient.prototype.deleteExtra =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/DeleteExtra',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_DeleteExtra,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.DeleteExtraRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.extra.v1.DeleteExtraResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIPromiseClient.prototype.deleteExtra =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/DeleteExtra',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_DeleteExtra);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.extra.v1.ReorderExtraRequest,
 *   !proto.witbooking.backoffice.extra.v1.ReorderExtraResponse>}
 */
const methodDescriptor_ExtraAPI_ReorderExtra = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.extra.v1.ExtraAPI/ReorderExtra',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.extra.v1.ReorderExtraRequest,
  proto.witbooking.backoffice.extra.v1.ReorderExtraResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.ReorderExtraResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.extra.v1.ReorderExtraRequest,
 *   !proto.witbooking.backoffice.extra.v1.ReorderExtraResponse>}
 */
const methodInfo_ExtraAPI_ReorderExtra = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.extra.v1.ReorderExtraResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.ReorderExtraResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.extra.v1.ReorderExtraResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.extra.v1.ReorderExtraResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIClient.prototype.reorderExtra =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/ReorderExtra',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_ReorderExtra,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.extra.v1.ReorderExtraResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIPromiseClient.prototype.reorderExtra =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/ReorderExtra',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_ReorderExtra);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest,
 *   !proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse>}
 */
const methodDescriptor_ExtraAPI_ReorderExtraMedias = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.extra.v1.ExtraAPI/ReorderExtraMedias',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest,
  proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest,
 *   !proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse>}
 */
const methodInfo_ExtraAPI_ReorderExtraMedias = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIClient.prototype.reorderExtraMedias =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/ReorderExtraMedias',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_ReorderExtraMedias,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.extra.v1.ReorderExtraMediasResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIPromiseClient.prototype.reorderExtraMedias =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/ReorderExtraMedias',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_ReorderExtraMedias);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest,
 *   !proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse>}
 */
const methodDescriptor_ExtraAPI_DownloadAppliedToExcel = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.extra.v1.ExtraAPI/DownloadAppliedToExcel',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest,
  proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest,
 *   !proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse>}
 */
const methodInfo_ExtraAPI_DownloadAppliedToExcel = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIClient.prototype.downloadAppliedToExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/DownloadAppliedToExcel',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_DownloadAppliedToExcel,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.extra.v1.DownloadAppliedToExcelResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIPromiseClient.prototype.downloadAppliedToExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/DownloadAppliedToExcel',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_DownloadAppliedToExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest,
 *   !proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse>}
 */
const methodDescriptor_ExtraAPI_DownloadInventoryLinesExcel = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.extra.v1.ExtraAPI/DownloadInventoryLinesExcel',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest,
  proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest,
 *   !proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse>}
 */
const methodInfo_ExtraAPI_DownloadInventoryLinesExcel = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIClient.prototype.downloadInventoryLinesExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/DownloadInventoryLinesExcel',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_DownloadInventoryLinesExcel,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.extra.v1.DownloadInventoryLinesExcelResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIPromiseClient.prototype.downloadInventoryLinesExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/DownloadInventoryLinesExcel',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_DownloadInventoryLinesExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest,
 *   !proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse>}
 */
const methodDescriptor_ExtraAPI_ProcessInventoryLinesExcel = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.extra.v1.ExtraAPI/ProcessInventoryLinesExcel',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest,
  proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest,
 *   !proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse>}
 */
const methodInfo_ExtraAPI_ProcessInventoryLinesExcel = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIClient.prototype.processInventoryLinesExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/ProcessInventoryLinesExcel',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_ProcessInventoryLinesExcel,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.extra.v1.ProcessInventoryLinesExcelResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIPromiseClient.prototype.processInventoryLinesExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/ProcessInventoryLinesExcel',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_ProcessInventoryLinesExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest,
 *   !proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse>}
 */
const methodDescriptor_ExtraAPI_SyncMultimedia = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.extra.v1.ExtraAPI/SyncMultimedia',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest,
  proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest,
 *   !proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse>}
 */
const methodInfo_ExtraAPI_SyncMultimedia = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse,
  /**
   * @param {!proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIClient.prototype.syncMultimedia =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/SyncMultimedia',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_SyncMultimedia,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.extra.v1.SyncMultimediaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.extra.v1.SyncMultimediaResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.extra.v1.ExtraAPIPromiseClient.prototype.syncMultimedia =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.extra.v1.ExtraAPI/SyncMultimedia',
      request,
      metadata || {},
      methodDescriptor_ExtraAPI_SyncMultimedia);
};


module.exports = proto.witbooking.backoffice.extra.v1;

